import React from 'react';

const NOTES = [
  { title: 'Purpose-built solutions', desc: 'We scope and build each engagement for your specific stack from the ground up.' },
  { title: 'Fast time to value', desc: 'Most projects are live within weeks. We scope for quick wins with measurable return.' },
  { title: 'Deep platform expertise', desc: 'We manage M365, Entra ID, Mimecast, and cloud infrastructure in live environments as our day job.' },
  { title: 'Security first by default', desc: 'We build least-privilege access, zero-trust design, and compliance into every project from the start.' },
  { title: 'End-to-end ownership', desc: 'You keep one point of contact from scoping through deployment and ongoing support.' },
  { title: 'Clear, honest pricing', desc: 'Project-based or retainer engagements with transparent scope and fixed pricing.' },
];

const WhyUs = () => (
  <section id="why" className="section section-alt" data-testid="why-section">
    <div className="wrap why-grid">
      <header className="section-head why-head">
        <h2 className="reveal">Practitioners who've done the work.</h2>
        <p className="lead reveal reveal-1">
          We've worked inside IT and operations teams. We know the tools, the constraints, and where things break.
        </p>
      </header>
      <div className="notes reveal reveal-2" data-ui>
        <div className="notes-head">
          <span>Every engagement</span>
          <span>Standard</span>
        </div>
        <ul>
          {NOTES.map((n) => (
            <li key={n.title} className="note">
              <span className="note-check" aria-hidden="true">
                <svg viewBox="0 0 12 12"><polyline points="2.5,6.2 5,8.6 9.5,3.4" /></svg>
              </span>
              <div>
                <h3>{n.title}</h3>
                <p>{n.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default WhyUs;
